import React, { useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Card } from 'react-bootstrap';
import { DraggableIcon } from '../../../components/icons/iconComponents';
const AnswerTypeRank = ({ data, qNo, handleRankChange }) => {
  console.log('RANK DATA', data);
  const [items, setItems] = useState([]);
  useEffect(() => {
    setItems(data?.options);

    return () => {
      setItems([]);
    };
  }, [qNo]);
  const onDragEnd = (result) => {
    const newItems = Array.from(items);
    const [removed] = newItems?.splice(result.source.index, 1);
    newItems?.splice(result?.destination?.index, 0, removed);
    let changedArray = newItems.map((_i, indx) => {
      return { ..._i, rank: indx + 1 };
    });
    setItems(changedArray);
    handleRankChange(changedArray);
  };

  console.log(
    'Question array inside',
    items?.map((i) => i.id),
    data?.options?.map((i) => i.id)
  );
  return (
    <>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {items.map((item, index) => (
                <Draggable key={`${item.id}`} draggableId={`${item.id}`} index={index}>
                  {(provided, snapshot) => (
                    // <ListItemCard provided={provided} snapshot={snapshot} item={item} />
                    <Card
                      className="draggableRow mb-3"
                      ref={provided.innerRef}
                      snapshot={snapshot}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <Card.Body className="d-flex justify-content-start align-items-center flex-row p-0">
                        <span className="px-4">
                          <DraggableIcon customClass="fs-2 text-black" />
                        </span>
                        <Card.Text className="p-4 me-3 mb-0 bg-light text-black fs-16 fw-semibold text-center">
                          {item.rank}
                        </Card.Text>
                        <Card.Title className="fs-16 m-0">{item.value}</Card.Title>
                      </Card.Body>
                    </Card>
                  )}
                </Draggable>
              ))}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </>
  );
};

export default AnswerTypeRank;
